export default {
  placeholders: {
    first_name: 'Voornaam',
    last_name: 'Achternaam',
    email: 'E-mail',
    mobile_number: 'Mobiel nummer',
  },
  labels: {
    exclusive_offers_via_email: 'Ik ontvang graag exclusieve aanbiedingen en nieuws per e-mail.',
  },
  buttons: {
    sign_up: 'Aanmelden',
  },
};
